module.exports = __webpack_public_path__ + "static/img/white-student-1.c7f0417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invitation/white-student-1.png
// module id = 7H9R
// module chunks = 2